module.exports = __webpack_public_path__ + "static/media/nota-notch.d336c925.svg";